import PublicApi from '@/services/PublicApi'

export default {
  clients () {
    return PublicApi().get('public/clients')
  },
  projects (id) {
    return PublicApi().get('public/projects', {params: { client_id: id }})
  },
  heros (name) {
    return PublicApi().get('public/heros', {params: { hero: name }})
  },  
}
